<div class="position-relative register-page" [ngStyle]="{
    backgroundColor:
      (Merchant$ | async)?.webapp_settings?.homepage_bottom_color ||
      (Merchant$ | async)?.menu_color,
  }"
>
  <section
    class="page-content d-flex align-items-center justify-content-center flex-fill"
  >
    <div class="login-box">
      <div class="login-box-body">
        <form #RegistrationForm="ngForm" (ngSubmit)="attempRegistration(RegistrationForm)" novalidate>
          <div class="row row-cols-2">
            <div class="col-12">
              <div class="row mb-2">
                <div class="col-12 text-center">
                  <label [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      'font-weight': 'bold',
                      'font-size': '1rem',
                    }"
                  >
                    Contact Details
                  </label>
                </div>
              </div>
              <div class="form-group">
                <input type="text" name="FirstName" required ngModel class="form-control text-center custom-input" placeholder="name" />

                @if (
                  RegistrationForm.controls["FirstName"]?.invalid &&
                  (RegistrationForm.controls["FirstName"].dirty ||
                  RegistrationForm.controls["FirstName"].touched)
                ) {
                  <span
                    [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                    }"
                  >
                    Please enter name
                  </span>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <input type="text" name="LastName" required ngModel class="form-control text-center custom-input"
                  placeholder="surname" />

                @if (
                  RegistrationForm.controls["LastName"]?.invalid &&
                  (RegistrationForm.controls["LastName"].dirty ||
                  RegistrationForm.controls["LastName"].touched)
                ) {
                  <span
                    [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                    }"
                  >
                    Please enter surname
                  </span>
                }
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <!-- <label
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae}">Country</label> -->
                <ng-select class="ng-select-md custom-ng-select" bindLabel="name" name="ddlcountry" required [items]="Country"
                  (change)="ValueChange($event)" [(ngModel)]="selectedCountry" placeholder="WhatsApp number country">
                </ng-select>
                @if (
                  RegistrationForm.controls["ddlcountry"]?.invalid &&
                  (RegistrationForm.controls["ddlcountry"].dirty ||
                  RegistrationForm.controls["ddlcountry"].touched)
                ) {
                  <div>
                    @if (
                      RegistrationForm.controls["ddlcountry"].errors.required
                    ) {
                      <span
                        [ngStyle]="{
                          color:
                            (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae ||
                            (Merchant$ | async)?.menu_font_color_homepgae,
                        }"
                      >
                        please select country
                      </span>
                    }
                  </div>
                }
                <!-- <ng-select class="ng-select-md" [items]="SelectOption" placeholder="-- Select country --"></ng-select> -->
              </div>
            </div>
            <!-- ------------- -->

            <div class="col-12">
              <div class="row g-2 align-items-center justify-content-center">
                <!-- Country Code (20%) -->
                <div class="col-3">
                  <input type="text" name="dialcode" [value]="dialcode" disabled
                    class="form-control text-center custom-input country-code" placeholder="dial code" />
                </div>

                <!-- Mobile Number (80%) -->
                <div class="col-9">
                  <input type="number" name="Mobile" required ngModel class="form-control text-center custom-input"
                    placeholder="mobile number" />
                </div>
              </div>
              
              <!-- Guidance text spanning full width, centered -->
              <div class="text-center mt-1 mb-3">
                <small class="guidance-text">
                  Enter mobile number without leading '0' eg: UAE: 501234567,
                  UK: 1234567890
                </small>
              </div>
              </div>

            <!-- <div class="col-12">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <div class="row g-2 align-items-center">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <div class="col-3">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <div class="form-group">
                                                                                                                <input type="text" name="dialcode" [value]="dialcode" disabled
                                                                                                                    class="form-control text-center custom-input country-code" placeholder="dial code">
                                                                                                                </div>
                                                                                                                </div>
                                                                                                                <div class="col-9">
                                                                                                                    <div class="form-group">
                                                                                                                        <input type="number" name="Mobile" required ngModel class="form-control text-center custom-input"
                                                                                                                            placeholder="mobile number">
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div class="col-12">
                                                                                                                    <small class="text-muted d-block text-center mt-1 guidance-text">
                                                                                                                        Enter mobile number without leading 0<br>
                                                                                                                        eg: UAR: 501278989, UK: 123456789
                                                                                                                    </small>
                                                                                                                </div>
                                                                                                                </div>
                                                                                                                </div> -->

            <div class="col-12">
              <div class="row mb-2">
                <div class="col-12 text-center">
                  <label [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      'font-weight': 'bold',
                      'font-size': '1rem',
                    }"
                  >
                    Login Credentials
                  </label>
                </div>
              </div>
              <div class="form-group">
                <input type="email" name="Email" required ngModel class="form-control text-center custom-input"
                  placeholder="email address" />
                @if (
                  RegistrationForm?.controls["Email"]?.invalid &&
                  (RegistrationForm.controls["Email"].dirty ||
                  RegistrationForm.controls["Email"].touched)
                ) {
                  <div>
                    @if (RegistrationForm?.controls["Email"].errors.required) {
                      <span
                        [ngStyle]="{
                          color:
                            (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae ||
                            (Merchant$ | async)?.menu_font_color_homepgae,
                        }"
                      >
                        Please enter email.
                      </span>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <input type="password" name="Password" required ngModel class="form-control text-center custom-input"
                  placeholder="password" />
                @if (
                  RegistrationForm.controls["Password"]?.invalid &&
                  (RegistrationForm.controls["Password"].dirty ||
                  RegistrationForm.controls["Password"].touched)
                ) {
                  <div>
                    @if (
                      RegistrationForm.controls["Password"].errors.required
                    ) {
                      <span
                        [ngStyle]="{
                          color:
                            (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae ||
                            (Merchant$ | async)?.menu_font_color_homepgae,
                        }"
                      >
                        Please enter password.
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <!-- class="form-control form-control-lg"  -->
                <input type="password" name="Rpassword" required ngModel class="form-control text-center custom-input"
                  placeholder="repeat password" />
                @if (
                  RegistrationForm.controls["Rpassword"]?.invalid &&
                  (RegistrationForm.controls["Rpassword"].dirty ||
                  RegistrationForm.controls["Rpassword"].touched)
                ) {
                  <div>
                    @if (
                      RegistrationForm.controls["Rpassword"].errors.required
                    ) {
                      <span
                        [ngStyle]="{
                          color:
                            (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae ||
                            (Merchant$ | async)?.menu_font_color_homepgae,
                        }"
                      >
                        Please re-enter password.
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
            <!-- <div class="col-12">
                            <div class="form-group">
                                <label
                                    [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae}">Email</label>
                                <input type="email" name="Email" required ngModel class="form-control form-control-lg"
                                    placeholder="Email address">
                                @if (RegistrationForm?.controls['Email']?.invalid &&
                                (RegistrationForm.controls['Email'].dirty ||
                                RegistrationForm.controls['Email'].touched)) {
                                <div>
                                    @if (RegistrationForm?.controls['Email'].errors.required) {
                                    <span
                                        [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae}">
                                        please Email Password.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div> -->
            <div class="col-12">
              <div class="row mb-2">
                <div class="col-12 text-center">
                  <label [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      'font-weight': 'bold',
                      'font-size': '1rem',
                    }"
                  >
                    Terms & Conditions and Privacy Policy
                  </label>
                </div>
              </div>
              <div class="form-group ml-3 pl-1">
                <input class="form-check-input" style="width: 20px; height: 20px" type="checkbox" [(ngModel)]="isPolicy"
                  (change)="PolicyPopup(1, $event)" name="isAccept" />
                <label class="form-check-label" [ngStyle]="{
                                    color:
                                      (Merchant$ | async)?.webapp_settings
                                        ?.menu_font_color_homepgae ||
                                      (Merchant$ | async)?.menu_font_color_homepgae,
                                    'font-size': 'medium',
                                    padding: '4px',
                  }"
                >
                  <!-- <a target="_blank" href="https://www.toodleglobal.com/terms-of-business/">Accept Terms &
                                                                                                                                                                                                                                                                            Conditions</a> -->
                  I agree to the
                  <a href="https://www.toodleglobal.com/terms-of-business/" target="_blank" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      'text-decoration': 'underline',
                    }"
                    >Terms & Conditions</a
                  >
                  and
                  <a
                    target="_blank"
                    href="https://www.toodleglobal.com/privacy-policy/"
                    [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      'text-decoration': 'underline',
                    }"
                    >Privacy Policies</a
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="text-center mb-2">
            <a href="https://www.toodleglobal.com/terms-of-business/" target="_blank" [ngStyle]="{
                color:
                  (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_homepgae ||
                  (Merchant$ | async)?.menu_font_color_homepgae,
                'text-decoration': 'underline',
              }"
              >toodle Terms</a
            >

            <span class="mx-2">|</span>
            <a href="https://www.toodleglobal.com/privacy-policy/" target="_blank" [ngStyle]="{
                color:
                  (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_homepgae ||
                  (Merchant$ | async)?.menu_font_color_homepgae,
                'text-decoration': 'underline',
              }"
              >toodle Privacy</a
            >

            <!-- <a href="javascript:void(0)" (click)="onVenuePrivacyClick()" target="_blank" class="policy-link">Venue Privacy </a> -->

            <!-- <a href="javascript:void(0)" [ngStyle]="{
                                                                                                                                                                                                                                            'color': (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae
                                                                                                                                                                                                                                              || (Merchant$ | async)?.menu_font_color_homepgae,
                                                                                                                                                                                                                                            'text-decoration': 'underline'
                                                                                                                                                                                                                                          }"
                                                                                                                            (click)="onVenuePrivacyClick()">
                                                                                                                            Venue Privacy
                                                                                                                        </a> -->

            <ng-container *ngIf="Merchant$ | async as merchant">
              <span *ngIf="shouldShowVenuePrivacy(merchant)" class="mx-2">|</span>
              <a *ngIf="shouldShowVenuePrivacy(merchant)" href="javascript:void(0)" [ngStyle]="{
                                color:
                                  merchant?.webapp_settings?.menu_font_color_homepgae ||
                                  merchant?.menu_font_color_homepgae,
                                'text-decoration': 'underline',
                }"
                (click)="onVenuePrivacyClick()"
              >
                Venue Privacy
              </a>
            </ng-container>
          </div>
          <div class="d-grid">
            <button type="submit" (ngSubmit)="attempRegistration(RegistrationForm)" [disabled]="!isPolicy" class="btn btn-lg mt-2"
              [ngStyle]="{
                backgroundColor:
                  (Merchant$ | async)?.webapp_settings?.menu_color ||
                  (Merchant$ | async)?.menu_color,
                color:
                  (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_homepgae ||
                  (Merchant$ | async)?.menu_font_color_homepgae,
                border: borderStyle,
              }"
            >
              Sign Up
            </button>
          </div>
        </form>
      </div>
      <div class="login-box-footer clearfix text-center">
        <!-- <div class="sign-up-link mt-4">
        <a routerLink="/forgot-password" class="text-white"> Sign In</a>
      </div> -->
      </div>
    </div>
  </section>
  <div id="registerTermsModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header" [ngStyle]="{
                'justify-content': 'right',
                height: '40px',
                backgroundColor:
                  (Merchant$ | async)?.webapp_settings?.menu_color ||
                  (Merchant$ | async)?.menu_color,
          'border-bottom': borderStyle,
        }"
      >
        <a (click)="close()" id="btnnotification" class="close-icon">
          <i [ngStyle]="{
                        color: menuBorderColor,
            }"
            class="zmdi zmdi-close zmdi-hc-fw"
          ></i>
        </a>
      </div>
      <div class="modal-body">
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
                    'white-space': 'break-spaces',
          }"
          id="textcontent"
        >
          I confirm that I have read the
          <a target="_blank" href="https://www.toodleglobal.com/privacy-policy/" style="text-decoration: underline">Privacy Policy
          </a>
          and I consent to Payar collecting information (see sections: Active
          and Passive Collection of Information) and using it for operational
          purposes (see section: Use of Information Collected) and sharing it
          with select third party service providers enabling them to perform the
          relevant service(s) (see section 'Sharing of Information')
          <br /><br />
          *Please ensure that location services are enabled for your browser
          else you will not be able to place orders with this application.*
        </p>
      </div>
      <div class="modal-footer">
        <button
          [ngStyle]="{
            color:
              (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
              (Merchant$ | async)?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border: borderStyle,
          }"
          (click)="PolicyPopup(2)"
        >
          Decline
        </button>
        <button
          [ngStyle]="{
            color:
              (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
              (Merchant$ | async)?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border: borderStyle,
          }"
          (click)="PolicyPopup(3)"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
  <div id="venuePrivacyModal" class="modal">
    <div class="modal-content">
      <!-- HEADER (same as myModal) -->
      <div class="modal-header" [ngStyle]="{
                'justify-content': 'right',
                height: '40px',
                backgroundColor:
                  (Merchant$ | async)?.webapp_settings?.menu_color ||
                  (Merchant$ | async)?.menu_color,
          'border-bottom': borderStyle,
        }"
      >
        <a (click)="closeVenuePrivacy()" class="close-icon">
          <i class="zmdi zmdi-close zmdi-hc-fw" [ngStyle]="{
                        color: menuBorderColor,
            }"
          >
          </i>
        </a>
      </div>
      
      <!-- BODY (same text style as myModal) -->
      <div class="modal-body">
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
                    'white-space': 'pre-line',
            'font-size': '14px',
          }"
        >
          <b>Privacy Policy</b>
          <br /><br />

          This Privacy Policy is issued by
          <b>{{ (Merchant$ | async)?.trade_name }}</b>, located at {{ (Merchant$ | async)?.registered_business_address }}.
          <br /><br />
          
          <b>Data Collection</b><br />
          We collect your name, email address, and mobile number solely to
          manage your account and provide access to our services.
          <br /><br />
          
          <b>Marketing & Data Use</b><br />
          Your data is used for authentication and service-related
          communication. By creating an account, you agree that the business may
          use your contact details for their own marketing purposes.
          <br /><br />
          
          <b>Opting Out</b><br />
          To opt out of receiving promotions or to request data deletion,
          contact the business directly at
          <b>{{ (Merchant$ | async)?.billing_email_address }}</b>. <br /><br />
          
          <b>Retention</b><br />
          We retain your data only for as long as your account remains active.
          This policy is governed by the laws of the country in which the
          business is located.
        </p>
      </div>
    </div>
  </div>
  </div>
